import React from 'react';
import ProjectOverview from '../../Components/ProjectOverview/ProjectOverview';
import styles from './Projects.scss';

export default class Projects extends React.Component {
    
    render(){
        return (
            <div className={styles.projects_overview}>
                <ProjectOverview />
            </div>
        );
    }
    
}


// WEBPACK FOOTER //
// ./src/Pages/Projects/Projects.js